import JSONParser from './JSONParser.js'
const breadcrumb = {
	init: function (wrapper) {
		if (wrapper.classList.contains('breadcrumb-initialized')) return

		wrapper.classList.add('breadcrumb-initialized')

		// parse data
		const data = JSONParser(wrapper.dataset.breadcrumb)
		const crumbs = []
		
		// create crumb elements from the data
		data.forEach(data => {
			// create a new crumb element
			const crumbElement = document.createElement('a')
			crumbElement.classList.add('crumb')
			crumbElement.index = crumbs.length

			crumbElement.innerText = data.title
			if(data.href){
				crumbElement.setAttribute('href', data.href)
			} else {
				crumbElement.setAttribute('href', '')
				crumbElement.classList.add('active')
			}

			crumbs.push(crumbElement)
		})

		crumbs.forEach(crumb => {
			const crumbIcon = document.createElement('span')
			crumbIcon.classList.add('material-symbols-rounded')
			crumbIcon.innerText = 'chevron_right'	
		
			wrapper.appendChild(crumb)
			wrapper.appendChild(crumbIcon)
		})

		wrapper.lastChild.remove()
	}
}

export default breadcrumb